import { FormControlLabel, Switch, Typography } from '@material-ui/core';
import { PagamentoResponse } from 'common/genericTypes';
import { GenericDrawer } from 'components/genericDrawer';
import { NumberField, SmSpace, TextField } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { formatDate } from 'utils/date';

interface SolicitarLiquidacaoBrutaAgenteFiduciarioDrawerProps {
  pagamento?: PagamentoResponse;
  opened: boolean;
  onClose(): void;
  onSubmitSuccess?(): void;
  onReprovar?(): void;
}

export const SolicitarLiquidacaoBrutaAgenteFiduciarioDrawer: React.FC<SolicitarLiquidacaoBrutaAgenteFiduciarioDrawerProps> = ({
  pagamento,
  opened,
  onClose,
  onSubmitSuccess,
  onReprovar,
}) => {
  const [rejeitarPu, setRejeitarPu] = useState(false);
  const [puAgenteFiduciario, setPuAgenteFiduciario] = useState<number>(0);

  const dispatch = useDispatch();
  const { postAprovarPUAF, postReprovarPUAF } = useSelector((state: RootState) => state.instrumentoApi);

  useEffect(() => {
    if (!opened) {
      setRejeitarPu(false);
      setPuAgenteFiduciario(0);
    }
  }, [opened]);

  const handleSolicitarLiquidacao = async () => {
    if (!pagamento) return;

    try {
      await postAprovarPUAF(dispatch, pagamento.id, {
        aceitouPUEmissor: true,
      });
      onSubmitSuccess?.();
    } catch {}
  };

  const handleReprovar = async () => {
    if (!pagamento) return;

    try {
      await postReprovarPUAF(dispatch, pagamento.id, {
        puAgenteFiduciario,
      });
      onReprovar?.();
    } catch {}
  };

  const puValue = pagamento?.puProjetado ?? 0;

  const drawerButtons = rejeitarPu
    ? [
        {
          buttonText: 'Reprovar PU do Emissor',
          buttonAction: handleReprovar,
          buttonColor: 'error' as const,
        },
        {
          buttonText: 'Cancelar',
          buttonAction: onClose,
        },
      ]
    : [
        {
          buttonText: 'Aceitar e Solicitar Liquidação',
          buttonAction: handleSolicitarLiquidacao,
          buttonColor: 'primary' as const,
        },
        {
          buttonText: 'Cancelar',
          buttonAction: onClose,
        },
      ];

  return (
    <GenericDrawer
      opened={opened}
      onClose={onClose}
      title="Solicitar Liquidação"
      buttons={drawerButtons}
    >
      <TextField
        label="Data do Vencimento"
        value={pagamento?.dataVencimento ? formatDate(pagamento.dataVencimento) : ''}
        disabled
      />
      <SmSpace />

      <NumberField
        label="PU Emissor"
        value={puValue}
        onChange={() => {}}
        numberType="eightDecimals"
        disabled
      />
      <SmSpace />

      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={rejeitarPu}
            onChange={() => setRejeitarPu(!rejeitarPu)}
          />
        }
        label={
          <Typography variant="body2">
            Reprovar valor do PU do Emissor
          </Typography>
        }
      />
      <SmSpace />

      {rejeitarPu && (
        <>
          <NumberField
            label="PU Agente Fiduciário"
            value={puAgenteFiduciario}
            onChange={(value) => setPuAgenteFiduciario(value ?? 0)}
            numberType="eightDecimals"
            required
          />
          <SmSpace />
        </>
      )}

      <div style={{ marginTop: 64 }} />
    </GenericDrawer>
  );
};
